import { RuleTableHandlers, TableConfig } from "../../../../../shared/ui/custom-table/model/table-config.model";

export function createGrantTableConfig(
  handlers: RuleTableHandlers = {},
  options: { filterView?: string, defaultFilter?: any } = {}
): TableConfig {
  const {
    onCreate = () => { },
    onAction = () => { },
    actionMap = {},
    onRowClick = () => { },
    onRowDblClick = () => { },
    onRowExpand = () => { },
    selectable = false,
    summaryTemplate = () => { },
    rowConfig = {},
    headerActions,
    gridActions,
    columns,
  } = handlers;

  const handleAction = (row: any, action: TableRowAction) => {
    if (actionMap[action]) {
      actionMap[action](row);
    } else {
      onAction(row, action);
    }
  };

  return {
    columns: columns,
    actions: [
      { label: 'Editar', icon: 'edit', callback: (row) => handleAction(row, TableRowAction.Edit) },
      {
        label: 'Documento (imagen)',
        icon: 'image',
        visible: (row) => row.image === true,
        callback: (row) => handleAction(row, TableRowAction.DownloadImage),
      },
      {
        label: 'Documento (PDF)',
        icon: 'attachment',
        visible: (row) => row.pdf === true,
        callback: (row) => handleAction(row, TableRowAction.DownloadPdf),
      },
      { label: 'Eliminar', icon: 'delete', callback: (row) => handleAction(row, TableRowAction.Delete) },
    ],
    gridActions: gridActions,
    headerActions: headerActions,
    filterView: options.filterView || 'viewSummaryGrantFilters',
    defaultFilter: options.defaultFilter || {},
    rowConfig: {
      ...rowConfig,
      clickable: true,
      onClick: onRowClick,
      onDoubleClick: onRowDblClick,
      onExpand: onRowExpand,
    },
    selectable: selectable,
    pagination: false,
    summaryTemplate: summaryTemplate,
  };
}

export enum TableRowAction {
  Edit = 'edit',
  Delete = 'delete',
  DownloadImage = 'downloadImage',
  DownloadPdf = 'downloadPdf',
}
